import { UnifiedResponse } from "../../../models/Response/unifiedResponse";
import androidAppApi from "../api/androidApp.api";
import { AppAnalyticsInsertRequest } from "../models/request/appAnalyticsInsertRequest";
import { AndroidAppResponse } from "../models/response/androidAppResponse";

const androidAppService = {
    getAndroidApp: async (): Promise<UnifiedResponse<AndroidAppResponse>> => {
        return await androidAppApi.getAndroidApp();
    },
    insertAppAnalytics: async (data: AppAnalyticsInsertRequest): Promise<UnifiedResponse<any>> => {
        return await androidAppApi.insertAppAnalytics(data);
    }
}

export default androidAppService;